(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-packs"] && !Shopify.designMode) return;
  try {
    
(function(){
  var items = document.querySelectorAll('#meet-the-packs .st-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('st-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    items.forEach(function(el){ io.observe(el); });
  } else {
    items.forEach(function(el){ el.classList.add('st-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
  var items = document.querySelectorAll('#{{ "st-proof-" | append: section.id }} .st-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('st-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function(el){ io.observe(el); });
  } else {
    items.forEach(function(el){ el.classList.add('st-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  var items = document.querySelectorAll('.st-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('st-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function(el){ io.observe(el); });
  } else {
    items.forEach(function(el){ el.classList.add('st-in'); });
  }

  document.querySelectorAll('[data-st-ritual-video]').forEach(function(wrap){
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-st-ritual-play]');
    if (!video) return;

    var showPlay = function(){ if (playBtn) playBtn.hidden = false; };
    var hidePlay = function(){ if (playBtn) playBtn.hidden = true; };
    var tryPlay = function(){
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(hidePlay).catch(showPlay);
      } else if (video.paused) {
        showPlay();
      } else {
        hidePlay();
      }
    };

    video.addEventListener('playing', hidePlay);
    video.addEventListener('pause', function(){ if (!video.ended) showPlay(); });
    if (playBtn) {
      playBtn.addEventListener('click', function(){
        video.muted = true;
        tryPlay();
      });
    }
    tryPlay();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
